import React, { useState } from 'react'
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from 'reactstrap'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

const Menu = ({
  onClickDelete,
  onClickEdit
}) => {
  const { t } = useTranslation('commons')
  const [isOpen, setIsOpen] = useState(false)
  const toggle = () => setIsOpen(!isOpen)

  return (
    <Dropdown
      isOpen={isOpen}
      name="settings-menu"
      toggle={toggle}
    >
      <DropdownToggle nav className="p-0">
        <div className="vertical-triple-dots" />
      </DropdownToggle>
      <DropdownMenu end>
        <DropdownItem
          name="edit"
          onClick={(event) => onClickEdit(event)}
        >
          {t('buttons.edit')}
        </DropdownItem>
        <DropdownItem divider />
        <DropdownItem
          className="text-danger"
          name="delete"
          onClick={(event) => onClickDelete(event)}
        >
          {t('buttons.delete')}
        </DropdownItem>
      </DropdownMenu>
    </Dropdown>
  )
}

Menu.propTypes = {
  onClickDelete: PropTypes.func.isRequired,
  onClickEdit: PropTypes.func.isRequired
}

export default Menu
